import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';

import { IconWrapper } from 'components/Icon';
import { JobAdsMap } from './JobAdsMap';

export const JobAdsMapDialog = ({ open, onClose, title = 'Job ads on map', closeLabel = 'Close', ...mapProps }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog open={open} onClose={onClose} fullScreen={fullScreen} fullWidth maxWidth="lg">
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
        <Typography variant="h5" fontWeight="bold">
          {title}
        </Typography>
        <IconButton aria-label={closeLabel} onClick={onClose}>
          <IconWrapper icon="xMark" sx={{ svg: { mt: -1 } }} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ height: fullScreen ? 1 : '75vh', display: 'flex', flexDirection: 'column' }}>
        {open && <JobAdsMap {...mapProps} />}
      </DialogContent>
    </Dialog>
  );
};
